import AppApi from '../shared/App.api';

export default { getPowerBICredentials, listPowerBIReports };

function getPowerBICredentials(reportId, region = null) {
  let url = `/admin/powerbi-credentials?report=${encodeURIComponent(reportId)}`;
  if (region) url += `&region=${encodeURIComponent(region)}`;
  return AppApi.get(url);
}

function listPowerBIReports() {
  return AppApi.get('/admin/powerbi-reports');
}
